import styled from 'styled-components';

export const CXIDashboardStartupSummaries = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.6rem;

    @media (min-width: 992px) and (max-width: 1199px) {
        gap: 3.2rem;
        .cxi-layout:not(.is-open) & {
            display: grid;
            grid-template: 'a b' auto / 1fr 1fr;
        }
    }
    @media (min-width: 1200px) {
        display: grid;
        gap: 3.2rem;
        grid-template: 'a b' auto / 1fr 1fr;
    }

    .technology .area-body {
        @media (min-width: 992px) {
            .cxi-layout:not(.is-open) & {
                flex-direction: row;
                gap: 3.2rem;
            }
        }
        @media (min-width: 1200px) {
            flex-direction: row;
            gap: 3.2rem;
        }
    }
`;

export const CXIDashboardStartupSummariesTechnology = styled.dl`
    break-inside: avoid-column;

    dt {
        color: ${({ theme }) => theme.colors.energyBlue};
        font-size: 1.4rem;
        font-weight: 700;
        margin: 0;
    }
    dd {
        color: ${({ theme }) => theme.colors.neutralDark}
        font-size: 1.6rem;
        font-weight: 600;
        margin: 0.2rem 0 0;

        & + dt {
            margin-top: 1.4rem;
        }
    }
`;

export const CXIDashboardStartupSummariesResearcher = styled.dl`
    break-inside: avoid-column;

    dt {
        color: ${({ theme }) => theme.colors.energyBlue};
        font-size: 1.4rem;
        font-weight: 700;
        margin: 0;
    }
    dd {
        color: ${({ theme }) => theme.colors.neutralDark}
        font-size: 1.6rem;
        font-weight: 600;
        margin: 0.2rem 0 0;

        & + dt {
            margin-top: 1.4rem;
        }
    }
`;
